<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h1 class="toc_head">Contents</h1>
<h2 class="toc"><a href="#/xhtml/06_Sources"><em class="italic">Sources</em></a></h2>
<h2 class="toc0"><a href="#/xhtml/07_Prologue"><em class="italic">Prologue</em></a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter01"><span class="bold">Chapter 1</span><span class="space1">Slavers, Baymen and Buccaneers</span></a></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample"><span class="bold">Chapter 2</span><span class="space1">A Thief from Horseferry</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample"><span class="bold">Chapter 3</span><span class="space1">The Parting Glass</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample"><span class="bold">Chapter 4</span><span class="space1">Trouble in Port Roseway</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample"><span class="bold">Chapter 5</span><span class="space1">Across the Atlantic and Back Again</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><span class="bold">Chapter 6</span><span class="space1">The Marooning of Philip Ashton</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample"><span class="bold">Chapter 7</span><span class="space1">HMS <em class="italic">Greyhound</em></span></span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample"><span class="bold">Chapter 8</span><span class="space1">Hanged by the Neck</span></span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample"><span class="bold">Chapter 9</span><span class="space1">A Vanishing Trick</span></span></h2>
<h2 class="toc"><span href="#/xhtml/17_Epilogue" title="Link target outside of Sample"><em class="italic">Epilogue</em>: The Treasure of Isle Haute</span></h2>
<h2 class="toc0"><span href="#/xhtml/18_Members" title="Link target outside of Sample"><em class="italic">Members of Ned Low’s Crew Captured by HMS</em> Greyhound</span></h2>
<h2 class="toc0"><span href="#/xhtml/19_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
<h2 class="toc0"><span href="#/xhtml/20_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="toc0"><span href="#/xhtml/21_Platesection" title="Link target outside of Sample">Plate Section</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?0a1257fd